import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import MyEditor from "../../Components/MyEditor/Myeditor";

const API = process.env.REACT_APP_API_BASE_URL;

const PublicEditorial = () => {
  const [judul, setJudul] = useState("");
  const [kategori, setKategori] = useState("opini");
  const [kategoriWeb, setKategoriWeb] = useState("Nasional");
  const [deskripsi, setDeskripsi] = useState("");
  const [author, setAuthor] = useState("");
  const [gambar, setGambar] = useState<File | null>(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const handleImage = (e: any) => {
    const file = e.target.files[0];
    setGambar(file);

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("judul", judul);
    formData.append("kategori", kategori);
    formData.append("kategori_web", kategoriWeb);
    formData.append("deskripsi", deskripsi);
    formData.append("author", author);

    if (gambar) {
      formData.append("gambar", gambar);
    }

    try {
      await axios.post(`${API}/api/editorial/public/me`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Berhasil Mengirim Berita",
        text: "Terima kasih! Berita yang kamu kirim sedang dalam proses peninjauan oleh tim editor kami. Silakan cek secara berkala untuk mengetahui status publikasi berita kamu.",
      });

      setJudul("");
      setDeskripsi("");
      setAuthor("");
      setPreview("");
      setGambar(null);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal Mengirim",
        text: "Terjadi kesalahan saat mengirim berita. Silakan coba kembali.",
      });
    }
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50 py-10 px-4 font-signika">
        <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-xl p-8">
          <h1 className="text-2xl font-bold mb-6 text-center">Kirim Isu/informasi Kamu</h1>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Judul */}
            <div>
              <label className="font-medium">Judul Informasi</label>
              <input value={judul} onChange={(e) => setJudul(e.target.value)} required className="w-full border rounded-lg px-4 py-2 mt-1" />
            </div>

            {/* Kategori */}
            <div>
              <label className="font-medium">Kategori</label>
              <select value={kategori} onChange={(e) => setKategori(e.target.value)} className="w-full border rounded-lg px-4 py-2 mt-1">
                <option value="opini">Opini</option>
                <option value="analisa">Analisa</option>
              </select>
            </div>

            {/* Kategori Web */}
            <div>
              <label className="font-medium">Kategori Website</label>
              <select value={kategoriWeb} onChange={(e) => setKategoriWeb(e.target.value)} className="w-full border rounded-lg px-4 py-2 mt-1">
                <option>Nasional</option>
                <option>Politik</option>
                <option>Ekonomi</option>
                <option>Olahraga</option>
                <option>Teknologi</option>
                <option>Internasional</option>
              </select>
            </div>

            {/* Author */}
            <div>
              <label className="font-medium">Nama Penulis</label>
              <input value={author} onChange={(e) => setAuthor(e.target.value)} required className="w-full border rounded-lg px-4 py-2 mt-1" />
            </div>

            {/* Deskripsi */}
            <div>
              <label className="font-medium">Isi Berita</label>
              <MyEditor value={deskripsi} onChange={setDeskripsi} />
            </div>

            {/* Upload Gambar */}
            <div>
              <label className="font-medium">Upload Gambar</label>

              <div className="mt-2 border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-red-500 transition">
                <input type="file" accept="image/*" onChange={handleImage} className="hidden" id="upload-image" />

                <label htmlFor="upload-image" className="cursor-pointer block">
                  {!preview ? (
                    <div className="space-y-2">
                      <p className="text-gray-500">Klik atau drag gambar ke sini</p>
                      <p className="text-sm text-gray-400">Hanya file JPG, PNG, WEBP (Max 2MB)</p>
                    </div>
                  ) : (
                    <div className="relative">
                      <img src={preview} alt="preview" className="w-full h-60 object-cover rounded-lg" />

                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setPreview("");
                          setGambar(null);
                        }}
                        className="absolute top-2 right-2 bg-red-600 text-white px-2 py-1 text-xs rounded">
                        Hapus
                      </button>
                    </div>
                  )}
                </label>
              </div>
            </div>

            {/* Button */}
            <button type="submit" className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition">
              Kirim Berita
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default PublicEditorial;
